/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: modules\pbxCli\pbxCliCommands.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Tools module.
────────────────────────────────────────────────────────────────*/


export interface CommandButton {
    label: string;
    tooltip: string;
    command: string;
}

export interface CommandGroup {
    name: string;
    commands: CommandButton[];
}

type FallbackRaw = {
    system?: { title?: string; items?: Record<string, string> };
    sip?: { title?: string; items?: Record<string, string> };
    calls?: { title?: string; items?: Record<string, string> };
};

export function buildFallbackCommandGroups(fallback: FallbackRaw): CommandGroup[] {
    return [
        {
            name: fallback.system?.title ?? 'System',
            commands: [
                { label: 'System Status',  tooltip: fallback.system?.items?.status    ?? '', command: 'fs_cli -x "status"' },
                { label: 'Version Info',   tooltip: fallback.system?.items?.version   ?? '', command: 'fs_cli -x "version"' },
                { label: 'Uptime',         tooltip: fallback.system?.items?.uptime    ?? '', command: 'fs_cli -x "uptime"' },
                { label: 'Modules List',   tooltip: fallback.system?.items?.modules   ?? '', command: 'fs_cli -x "modules list"' },
                { label: 'Reload XML',     tooltip: fallback.system?.items?.reloadXml ?? '', command: 'fs_cli -x "reloadxml"' },
            ],
        },
        {
            name: fallback.sip?.title ?? 'SIP',
            commands: [
                { label: 'SIP Profiles',    tooltip: fallback.sip?.items?.profiles  ?? '', command: 'fs_cli -x "sofia status"' },
                { label: 'Sofia Internal',  tooltip: fallback.sip?.items?.internal  ?? '', command: 'fs_cli -x "sofia status profile internal"' },
                { label: 'Sofia External',  tooltip: fallback.sip?.items?.external  ?? '', command: 'fs_cli -x "sofia status profile external"' },
                { label: 'Enable SIP Trace', tooltip: fallback.sip?.items?.traceOn  ?? '', command: 'fs_cli -x "sofia global siptrace on"' },
                { label: 'Disable SIP Trace', tooltip: fallback.sip?.items?.traceOff ?? '', command: 'fs_cli -x "sofia global siptrace off"' },
            ],
        },
        {
            name: fallback.calls?.title ?? 'Calls',
            commands: [
                { label: 'Active Calls', tooltip: fallback.calls?.items?.calls     ?? '', command: 'fs_cli -x "show calls"' },
                { label: 'Channels',     tooltip: fallback.calls?.items?.channels  ?? '', command: 'fs_cli -x "show channels"' },
                { label: 'Media Bugs',   tooltip: fallback.calls?.items?.mediaBugs ?? '', command: 'fs_cli -x "uuid_buglist"' },
                { label: 'Call Summary', tooltip: fallback.calls?.items?.summary   ?? '', command: 'fs_cli -x "show calls count"' },
            ],
        },
    ];
}
